import { EyeOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { BaseQuestionRendererProps } from './types'
import { ChartWrapper } from './shared'

export function EmailOmittedNote({ question }: BaseQuestionRendererProps) {
  const { t } = useTranslation()

  return (
    <ChartWrapper
      title={
        <div className="flex items-center gap-2">
          <EyeOff className="h-4 w-4" />
          {question.label}
        </div>
      }
      description={t('dashboard.charts.email_responses_excluded')}
    >
      <div className="flex w-full items-center justify-center py-8 text-muted-foreground">
        <div className="text-center">
          <EyeOff className="h-8 w-8 mx-auto mb-2" />
          <div className="text-sm">
            {t('dashboard.charts.email_privacy_message')}
          </div>
          <div className="text-xs mt-1">
            {t('dashboard.charts.responses_collected', {
              count: question.totalRespondents || 0,
            })}
          </div>
        </div>
      </div>
    </ChartWrapper>
  )
}
